import { DocusealForm } from '@docuseal/react'

import { Handler } from '../lib/typeHelper'

interface EsignEnvelopeProps {
  url: string
  onAgree: Handler
  onError: Handler
}

export function EsignEnvelope({ url, onAgree, onError: _onError }: EsignEnvelopeProps) {
  return <DocusealForm src={url} onComplete={() => onAgree()} withTitle={false} expand />
}
